var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBonus4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.17161C0.5 3.60746 2.74219 0.709686 5.5 0.709686H30.5C33.2578 0.709686 35.5 3.60746 35.5 7.17161V39.4812H0.5V7.17161Z",
    fill: "url(#paint0_linear_2056_1424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.5 37.6321H35.5V43.1709C35.5 46.2259 33.2578 48.7097 30.5 48.7097H5.5C2.74219 48.7097 0.5 46.2259 0.5 43.1709V37.6321ZM15.5 43.1709C15.5 43.9054 15.7634 44.6098 16.2322 45.1292C16.7011 45.6485 17.337 45.9403 18 45.9403C18.663 45.9403 19.2989 45.6485 19.7678 45.1292C20.2366 44.6098 20.5 43.9054 20.5 43.1709C20.5 42.4364 20.2366 41.732 19.7678 41.2126C19.2989 40.6933 18.663 40.4015 18 40.4015C17.337 40.4015 16.7011 40.6933 16.2322 41.2126C15.7634 41.732 15.5 42.4364 15.5 43.1709Z",
    fill: "url(#paint1_linear_2056_1424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2056_1424",
    x1: 0.5,
    y1: 20.0955,
    x2: 35.5,
    y2: 20.0955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2056_1424",
    x1: 0.5,
    y1: 43.1709,
    x2: 35.5,
    y2: 43.1709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8251"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBonus4);
export default __webpack_public_path__ + "static/media/icon-bonus-4.d1218a9b62a58e117fc64a8608f81f1a.svg";
export { ForwardRef as ReactComponent };